import mark from "../assets/logo-mark.svg";
import primary from "../assets/logo-primary.svg";
import primaryCream from "../assets/logo-primary-cream.svg";

export function Brand({
  compact = false,
  inverse = false,
}: {
  compact?: boolean;
  inverse?: boolean;
}) {
  return (
    <div className={compact ? "brand brand--compact" : "brand"}>
      <img
        src={compact ? mark : inverse ? primaryCream : primary}
        alt="Just Kasz"
        className="brand__logo"
      />
      {!compact && <span className="brand__product">CRM</span>}
    </div>
  );
}
